import { setOptions, importLibrary, APIOptions } from "@googlemaps/js-api-loader";
import { GoogleMapsParams, Map as GMap, Marker } from "./types";
import { useEffect, useRef } from "react";
import React from "react";

export default function GoogleMaps({ 
    apiKey, 
    options, 
    loaderOptions, 
    markers = [], 
    fallback, 
    ...callbacks 
}: GoogleMapsParams) {
    // const [ map, setMap ] = useState();
    const mapRef = useRef(null); 

    useEffect(() => {
        setOptions({
            key: apiKey,
            ...loaderOptions
        });

        importLibrary("maps")
            .then(({ Map }) => {
                const el : HTMLElement = mapRef.current;
                const m : GMap = new Map(el, options);

                // setMap(m);

                return m;
            })
            .then(m => registerCallbacks(m, callbacks))
            .then(m => placeMarkers(m, markers))
            .catch(e => callbacks.onError?.(e))
    }, []);

    return (
        <div
            ref={mapRef}
            style={{
                height:'100%'
            }}
        />
    )
}

/**
 * Register callbacks  
 * @param map 
 * @param callbacks 
 * @returns The input map object
 */
const registerCallbacks = (map: GMap, callbacks: any) => {
    const Events = google.maps.event;
    
    // Trigger callback when map is ready
    Events.addListenerOnce(map, "idle", () => callbacks.onLoaded?.(map))

    return map;
}

/** 
 * TODO: Return markers maybe?
 **/
const placeMarkers = async (map: GMap, markers: Marker[]) => {
    if (markers.length <= 0 || !map.getMapCapabilities().isAdvancedMarkersAvailable) { return; }
    
    const { AdvancedMarkerElement } = await importLibrary("marker");

    markers.map(marker => {
        new AdvancedMarkerElement({
            map,
            position: marker.position
        })
    })

    return map;
}